module.exports = __webpack_public_path__ + "img/productTitle2.e64cfe9e.png";